const f = (o, n) => {
  const l = o.querySelector(`#${n.value}`);
  function s(t, e) {
    for (const i of e) {
      const c = i.childElementCount > 1 ? i.children[0] : i;
      c instanceof HTMLElement && (t ? c.style.display = "none" : c.style.display = "");
    }
  }
  let a;
  function u(t) {
    const e = !!t;
    e !== a && (s(!e, [...o.querySelectorAll(`*[for=${n.value}]`).values()]), s(e, [...o.querySelectorAll(`*[for=not${n.value}]`).values()])), a = e;
  }
  u(l == null ? void 0 : l.value), l && l.addEventListener("input", (t) => {
    var e;
    return u((e = t == null ? void 0 : t.target) == null ? void 0 : e.value);
  });
};
export {
  f as h
};
//# sourceMappingURL=hide-label-cYI1fuDW.js.map
